import * as React from 'react'

import { SVGResponsive } from './common'

function Hamburger() {
  return (
    <SVGResponsive height={25} width={25}>
      <line x1="3" y1="6" x2="22" y2="6" stroke="currentColor" strokeWidth="2" />
      <line x1="3" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2" />
      <line x1="3" y1="18" x2="22" y2="18" stroke="currentColor" strokeWidth="2" />
    </SVGResponsive>
  )
}

export default React.memo(Hamburger)
